import { isLocalhost } from "replo-runtime/shared/env";

export const getAgentUrl = () => {
  if (isLocalhost()) {
    return `http://localhost:${process.env.REPLO_DEV_AGENT_PORT ?? "8787"}`;
  }
  if (localStorage.getItem("replo.debug.useBackendStaging") === "true") {
    return "https://cloudflare-agent-staging.replo.workers.dev";
  }
  return "https://cloudflare-agent-production.replo.workers.dev";
};
